<template>
  <div class="annuaire-asso flex-column d-flex">
    <header
      class="row flex-column justify-content-between flex-nowrap align-item-stretch"
      role="banner"
      id="banner"
      tabindex="-1"
    >
      <span v-if="!embedded" class="row title-level level-1 hidden-sm" role="heading" :aria-level="titleLevel">
        {{ i18n.title }}
      </span>
      <search-bar />
    </header>
    <div id="page-container" ref="page-container" class="page-container d-flex flex-column" @scroll="onScroll">
      <main class="row m-0 align-item-stretch align-content-stretch flex-wrap flex-sm-colum" id="main" role="main">
        <list-categorie v-if="categoriesShown" class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12" />
        <list-vignette
          :isScrollBtnShown="isScrollBtnShown"
          class="col-sm-12 col-xs-12"
          :class="{ 'col-xl-9 col-lg-9 col-md-8': categoriesShown }"
        />
      </main>
      <footer v-if="!embedded"></footer>
    </div>
  </div>
</template>

<script>
import SearchBar from '@/components/search-bar/SearchBar.vue';
import ListVignette from '@/components/list-vignette/ListVignette.vue';
import ListCategorie from '@/components/list-categorie/ListCategorie.vue';
import { titleLevelHelper } from '@/helpers/index.js';

export default {
  components: {
    ListVignette,
    SearchBar,
    ListCategorie,
  },
  data: function() {
    return {
      i18n: {
        title: this.$t(`title`),
      },
      titleLevel: titleLevelHelper.computeTitleLevel(1),
      isScrollBtnShown: false,
    };
  },
  computed: {
    embedded() {
      return this.$route.query.embedded === 'true';
    },
    // at least one categorie should be visible to display them
    categoriesShown() {
      return this.$store.state.categories.some((category) => this.$route.query[`${category}Hidden`] !== 'true');
    },
  },
  methods: {
    onScroll() {
      const node = this.$refs['page-container'];
      const position = node.scrollTop / (node.scrollHeight - node.clientHeight);
      this.isScrollBtnShown = position > 0.05;
    },
  },
  created: function() {
    this.$store.dispatch('search', true);
  },
};
</script>
<style lang="less">
@import url('../assets/styles/layout.less');
@import url('../assets/styles/header.less');
</style>
